import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {marketingProjectActions} from "./marketingProjectSlice";
import {marketingProjectApi} from "~/api";

function* fetchMarketingProjectList(action) {
	try {
		const response = yield call(marketingProjectApi.gets, action.payload);
		yield put(marketingProjectActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch marketing project list', error);
		yield put(marketingProjectActions.fetchDataFailed(error.message));
	}
}

function* handleSearchDebounce(action) {
	yield put(marketingProjectActions.setFilter(action.payload));
}

export default function* marketingProjectSaga() {
	yield takeLatest(marketingProjectActions.fetchData.type, fetchMarketingProjectList);
	yield debounce(500, marketingProjectActions.setFilterWithDebounce.type, handleSearchDebounce)
}
